// Court mapping utility
export const COURT_NAMES = {
  '13': 'Allahabad High Court',
  '1': 'Bombay High Court',
  '16': 'Calcutta High Court',
  '6': 'Gauhati High Court',
  '29': 'High Court for State of Telangana',
  '2': 'High Court of Andhra Pradesh',
  '18': 'High Court of Chhattisgarh',
  '26': 'High Court of Delhi',
  '17': 'High Court of Gujarat',
  '5': 'High Court of Himachal Pradesh',
  '12': 'High Court of Jammu and Kashmir',
  '7': 'High Court of Jharkhand',
  '3': 'High Court of Karnataka',
  '4': 'High Court of Kerala',
  '23': 'High Court of Madhya Pradesh',
  '25': 'High Court of Manipur',
  '21': 'High Court of Meghalaya',
  '11': 'High Court of Orissa',
  '22': 'High Court of Punjab and Haryana',
  '9': 'High Court of Rajasthan',
  '24': 'High Court of Sikkim',
  '20': 'High Court of Tripura',
  '15': 'High Court of Uttarakhand',
  '10': 'Madras High Court',
  '8': 'Patna High Court'
};
  
  /**
   * Get full court name from court code
   * @param {string} courtCode - Court code to look up
   * @returns {string} Full court name or the original code if not found
   */
  export function getFullCourtName(courtCode) {
    return COURT_NAMES[courtCode] || courtCode;
  }

  export const formatCaseTitle = (title) => {
    if (!title || typeof title !== 'string') {
      return ''; // Return empty string if title is invalid
    }
  
    try {
      const parts = title.split(' vs ');
      if (parts.length < 2) {
        // If ' vs ' isn't found, return a truncated version or original
        return title.length > 60 ? title.substring(0, 57) + '...' : title;
      }
  
      const petitionerPart = parts[0];
      const respondentPart = parts[1];
  
      // --- Extract Petitioner Name ---
      // Find text between the initial number/symbol (like "1)") and "Advocate-"
      const petitionerMatch = petitionerPart.match(/^.*?\)\s*(.*?)\s*Advocate-/);
      let shortPetitioner = '';
      let petitionerPrefix = '1) '; // Default prefix
  
      if (petitionerMatch && petitionerMatch[1]) {
        // Extract prefix (like "1) ")
        const prefixMatch = petitionerPart.match(/^.*?\)\s*/);
        if (prefixMatch) {
            petitionerPrefix = prefixMatch[0];
        }
        // Get the name part and take the first 2 words
        const petitionerName = petitionerMatch[1].trim();
        const petitionerWords = petitionerName.split(/\s+/); // Split by whitespace
        shortPetitioner = petitionerWords.slice(0, 2).join(' '); // e.g., "M/S SETHI"
      } else {
        // Fallback: Take the first few words from the petitioner part
        const petitionerWords = petitionerPart.replace(/^.*?\)\s*/, '').trim().split(/\s+/);
        shortPetitioner = petitionerWords.slice(0, 2).join(' ');
         // Try to get prefix anyway
        const prefixMatch = petitionerPart.match(/^.*?\)\s*/);
        if (prefixMatch) {
            petitionerPrefix = prefixMatch[0];
        }
      }
  
      // --- Extract First Respondent Name ---
      // Find text between "1)" and "Advocate -" within the respondent part
      const respondentMatch = respondentPart.match(/1\)\s*(.*?)\s*Advocate\s*-/);
      let shortRespondent = '';
      let respondentPrefix = '1) '; // Default prefix for first respondent
  
      if (respondentMatch && respondentMatch[1]) {
          // Prefix is known to be "1) " because we searched for it
          respondentPrefix = '1) ';
        // Get the name part and take the first 3 words
        const respondentName = respondentMatch[1].trim();
        const respondentWords = respondentName.split(/\s+/); // Split by whitespace
        shortRespondent = respondentWords.slice(0, 3).join(' '); // e.g., "STATE OF U.P."
      } else {
         // Fallback: Try to find "1)" and take some text after it
         const respStartIndex = respondentPart.indexOf('1)');
         if (respStartIndex !== -1) {
             respondentPrefix = '1) ';
             // Extract text after "1) ", trim, split, take first few words
             const potentialName = respondentPart.substring(respStartIndex + 2).split('Advocate')[0].trim();
             shortRespondent = potentialName.split(/\s+/).slice(0, 3).join(' ');
         } else {
             // Final fallback for respondent if "1)" not found
             shortRespondent = respondentPart.split(/\s+/).slice(0, 3).join(' ');
             respondentPrefix = ''; // No prefix found
         }
      }
  
      // Ensure we have fallback text if extraction failed
      if (!shortPetitioner) shortPetitioner = "[Petitioner]";
      if (!shortRespondent) shortRespondent = "[Respondent]";
  
      // --- Combine ---
      return `${petitionerPrefix}${shortPetitioner} ..... VS ${respondentPrefix}${shortRespondent} ........`;
  
    } catch (error) {
      console.error("Error formatting case title:", error);
      // Fallback to original title in case of any unexpected error
      return title;
    }
  };